module.exports = __webpack_public_path__ + "media/email.d12ab6ba.svg";


//////////////////
// WEBPACK FOOTER
// ./src/templates/fashionIcon/assets/email.svg
// module id = ./src/templates/fashionIcon/assets/email.svg
// module chunks = 0